import React from "react";
import PasswordReset from '../Components/PasswordReset.jsx';
import { UserProvider } from '../Providers/UserProvider';
import ChangePasswordForm from '../Forms/ChangePasswordForm.jsx';
import { BaseProvider } from './../Providers/BaseProvider';




export default class ConfirmPassword extends React.Component {
	state = {
		success: false,
		form: {
			password: '',
			password2: ''
		}
	}

	handleChangePassword = (values, actions) => {
		UserProvider.resetPassword(
			{
				userId: this.props.userId,
				token: this.props.token,
				password: values.password
			}, () => {
				this.setState({ success: true });
		},
			(err) => {
				BaseProvider.applyServerFormValidation(actions, err);
			}
		);
	}

	handleChangeField = (e, prop) => {
		var form = this.state.form;
		form[prop] = e.target.value;
		this.setState({ form: form });
	}


	render() {

		if (this.state.success) {
			return <PasswordReset />;
		}
		else {
			var T = window.Texts.login;
			let form = this.state.form;
			return (
				<div className="password-change-page">
					<div className="cover">
						<div className="headline">
							<h1>{T.confirmPasswordTitle}</h1>
						</div>
						<div className="inner-305">
							<ChangePasswordForm onSubmit={(values, setSubmitting) => this.handleChangePassword(values, setSubmitting)} />
						</div>
					</div>
				</div>);
		}
	}
}